import React from 'react';
import './LoadingPulse.scss';

type LoadingPulseProps = {
    message?: string;
};

const LoadingPulse: React.FC<LoadingPulseProps> = ({ message = 'Loading...' }) => {
    return (
        <div className="loading-pulse">
            <div className="loading-pulse__dot"></div>
            {message && <div className="loading-pulse__message">{message}</div>}
        </div>
    );
};

export default LoadingPulse;

